
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos/official-scrum-fundamentals-certification-training",
      function () {
        return require("private-next-pages/entrenamientos/official-scrum-fundamentals-certification-training.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entrenamientos/official-scrum-fundamentals-certification-training"])
      });
    }
  